

export const PrivacyTab = () => {
    return (
        <div>
            <h1>Privacy</h1>
        </div>
    )
}